const hasWindowLocation = () => typeof window !== 'undefined' && window.location;

export const getApiBaseUrl = () => {
	if (hasWindowLocation()) {
		return '/api';
	}
	return process.env.VUE_APP_BASE_API || '/api';
};

export const getWsUrl = () => {
	if (hasWindowLocation()) {
		const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
		return `${wsProtocol}//${window.location.host}/im`;
	}
	return process.env.VUE_APP_WS_URL || '';
};
